import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PanelConfComponent } from './panel/components/panel-conf/panel-conf.component';
import { VehiclesComponent } from './vehicles/components/vehicles/vehicles.component';
import { SessionComponent } from './vehicles/components/session/session.component';
import { AuthGuard } from './core/guards/auth.guard';
import { IsLoggedGuard } from './core/guards/islogged.guard';
import { MapComponent } from './vehicles/components/map/map.component';

import { NewReportComponent } from './reports/components/new-report/new-report.component';
import { ReportViewerComponent } from './reports/components/report-viewer/report-viewer.component';

import { ReportComponent } from './reports/components/report/report.component';
import { ResultComponent } from './reports/components/result/result.component';
import { RpMainComponent } from './rep-programados/components/rp-main/rp-main.component';
import { FollowMainComponent } from './follow-link/components/follow-main/follow-main.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuditComponent } from './auditoria/components/audit/audit.component';
import { AuditresultComponent } from './auditoria/components/auditresult/auditresult.component';
import { NotFoundComponent } from './panel/not-found/not-found.component';
import { ScreenViewComponent } from './multiview/screen-view/screen-view.component';
import { LicenseGuard } from './core/guards/license.guard';
import { LicenseComponent } from './license/license.component';
import { LicenseInvalidGuard } from './core/guards/license-invalid.guard';


import { FleetChecklistListViewComponent, FleetChecklistViewComponent } from './validation/views';

// import { AuthGuard } from './vehicles/services/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
    canActivate: [IsLoggedGuard],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'validation',
    canActivate: [AuthGuard, LicenseGuard],
    children: [
      { path: '', component: FleetChecklistListViewComponent },
      // { path: 'create', component: ValidationCreateComponent },
      { path: ':id', component: FleetChecklistViewComponent}
    ]
  },
  {
    path: 'panel',
    component: PanelConfComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'vehicles',
    // canActivate: [ AuthGuard ],
    component: MapComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'reports',
    component: ReportComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'reports/result',
    component: ResultComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'new-reports',
    component: NewReportComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'new-reports/result',
    component: ReportViewerComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'rprogramados',
    component: RpMainComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'seguimiento/:id_seguimiento',
    component: FollowMainComponent,
  },
  {
    path: 'audit',
    component: AuditComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'session',
    component: SessionComponent,
  },
  {
    path: 'multiview/:name',
    component: ScreenViewComponent,
    canActivate: [AuthGuard, LicenseGuard],
  },
  {
    path: 'license',
    component: LicenseComponent,
    canActivate: [LicenseInvalidGuard],
  },
  {
    path: '**',
    //component: NotFoundComponent,
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
